import React, { useContext, useState, useEffect, useRef } from 'react';
import ListItem from './ListItem';
import { Table } from 'reactstrap';
import styled from 'styled-components';
import NoItems, { ContentType } from 'components/NoItems';
import UserContext from 'containers/contexts/UserContext.js';
import { RoleHelper } from '@shoflo/polymer/helpers/RoleHelper/RoleHelper';
import { getDateFormat } from 'utils/teamHelper';

const StyledHeaderCell = styled.th`
  font-size: 16px;
  font-style: normal;
  font-weight: normal;
  color: #767676 !important;
  border: none !important;
  padding: 2rem 0 0.5rem !important;
`;
const PhotoColumnHeader = styled(StyledHeaderCell)`
  width: 112px !important;

  @media only screen and (max-width: 768px) {
    opacity: 0;
    width: 120px;
  }

  @media only screen and (max-width: 540px) {
    width: 50px;
  }
`;
const OptionsHeader = styled(StyledHeaderCell)`
  padding: 0 !important;
  width: 100px;

  @media only screen and (max-width: 768px) {
    width: 50px;
  }
`;
const OptionsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
const TitleColumnHeader = styled(StyledHeaderCell)`
  width: 350px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  @media only screen and (max-width: 768px) {
    width: 350px;
  }

  @media only screen and (max-width: 540px) {
    width: 100%;
  }
`;
const LabelColumnHeader = styled(StyledHeaderCell)`
  width: 150px;
`;
const OwnerColumnHeader = styled(StyledHeaderCell)`
  width: 260px;

  @media only screen and (max-width: 768px) {
    width: 50px;
  }
`;
const StyledTable = styled(Table)`
  table-layout: fixed;

  tbody tr {
    td {
      transition: background 0.2s;
    }
    td img,
    td .default-image {
      transition: transform 0.2s;
    }

    &:hover {
      td {
        background: #f5fbff;

        &:first-child {
          img,
          .default-image {
            transform: translateX(5px);
          }
        }

        &:last-child {
          button.btn {
            border: 1px solid #767676;
            transform: translateX(-5px);
          }
        }
      }
    }
  }
`;

const StyledTableHead = styled.thead`
  th {
    position: sticky;
    top: ${(props) => props.stickytop};
    background: #fff;
    z-index: 2;
  }
`;

const StyledTBody = styled.tbody`
  @media only screen and (max-width: 576px) {
    transform: translateY(15px);
  }
`;

export {
  StyledHeaderCell,
  StyledTBody,
  StyledTable,
  StyledTableHead,
  OwnerColumnHeader,
  LabelColumnHeader,
  TitleColumnHeader,
  PhotoColumnHeader,
  OptionsHeader,
  OptionsWrapper,
};

const EventList = (props) => {
  const {
    createEventButton,
    events,
    onEditClick,
    onViewClick,
    onDuplicateClick,
    onArchiveClick,
    eventSearchNode,
    isLoading,
    noItemsNode,
    team,
  } = props;

  const dateFormat = getDateFormat(team || {});

  const tableRef = useRef();
  const [tableHeaderTop, setTableHeaderTop] = useState(0);

  const user = useContext(UserContext);

  useEffect(() => {
    setTableHeaderTop(tableRef.current.getBoundingClientRect().top);
  }, []);

  const rows =
    events.length >= 1
      ? events.map((evt) => {
          const teamId = evt.team._id ? evt.team._id : evt.team;

          const isEventAdmin = RoleHelper.hasEventAdminRole(
            user,
            teamId,
            evt._id,
          );

          return (
            <ListItem
              key={`evt-table-row-${evt._id}`}
              event={evt}
              hasMenu={isEventAdmin}
              {...{
                onEditClick,
                onDuplicateClick,
                onViewClick,
                onArchiveClick,
                dateFormat,
              }}
            />
          );
        })
      : null;

  return (
    <StyledTable>
      <StyledTableHead stickytop={`${tableHeaderTop}px`} ref={tableRef}>
        <tr>
          <PhotoColumnHeader>Event</PhotoColumnHeader>
          <TitleColumnHeader></TitleColumnHeader>
          <LabelColumnHeader className="d-none d-lg-table-cell">
            Labels
          </LabelColumnHeader>
          <OwnerColumnHeader className="d-none d-lg-table-cell">
            Owner
          </OwnerColumnHeader>
          <OptionsHeader>
            <OptionsWrapper>
              {events.length ? eventSearchNode : null}
              {createEventButton}
            </OptionsWrapper>
          </OptionsHeader>
        </tr>
      </StyledTableHead>
      <StyledTBody>
        {!rows && isLoading && (
          <NoItems type={ContentType.Event} isLoading={isLoading} />
        )}

        {!rows && !isLoading
          ? noItemsNode || (
              <NoItems
                title="You don’t have any events!"
                subTitle="The world is waiting."
                showArrow={true}
                isLoading={isLoading}
                type={ContentType.Event}
              />
            )
          : rows}
      </StyledTBody>
    </StyledTable>
  );
};

export default EventList;
